import React, { useState } from 'react';
import { Settings, Save, Database, Wifi, Activity } from 'lucide-react';

function ConfigPanel({ plantaId }) {
  const [config, setConfig] = useState({
    pollingInterval: 5000,
    reconnectInterval: 10000,
    mqttQos: 1,
    mqttRetain: false,
    logLevel: 'info'
  });

  const handleSave = () => {
    alert('Funcionalidad de guardado en desarrollo');
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Configuración</h2>
        <p className="text-gray-600">
          Ajusta los parámetros del sistema
        </p>
      </div>

      {/* Configuración de Conexiones */}
      <div className="card">
        <div className="flex items-center space-x-3 mb-4">
          <Wifi className="w-6 h-6 text-primary-600" />
          <h3 className="text-lg font-semibold text-gray-900">Conexiones</h3>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Intervalo de Polling (ms)
            </label>
            <input
              type="number"
              value={config.pollingInterval}
              onChange={(e) => setConfig({ ...config, pollingInterval: parseInt(e.target.value) })}
              className="input"
              min="1000"
              max="60000"
              step="1000"
            />
            <p className="text-sm text-gray-500 mt-1">
              Frecuencia de lectura de variables OPC UA
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Intervalo de Reconexión (ms)
            </label>
            <input
              type="number"
              value={config.reconnectInterval}
              onChange={(e) => setConfig({ ...config, reconnectInterval: parseInt(e.target.value) })}
              className="input"
              min="5000"
              max="60000"
              step="5000"
            />
            <p className="text-sm text-gray-500 mt-1">
              Tiempo de espera antes de reintentar conexión
            </p>
          </div>
        </div>
      </div>

      {/* Configuración MQTT */}
      <div className="card">
        <div className="flex items-center space-x-3 mb-4">
          <Activity className="w-6 h-6 text-primary-600" />
          <h3 className="text-lg font-semibold text-gray-900">MQTT</h3>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Quality of Service (QoS)
            </label>
            <select
              value={config.mqttQos}
              onChange={(e) => setConfig({ ...config, mqttQos: parseInt(e.target.value) })}
              className="input"
            >
              <option value="0">0 - At most once</option>
              <option value="1">1 - At least once</option>
              <option value="2">2 - Exactly once</option>
            </select>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              id="mqttRetain"
              checked={config.mqttRetain}
              onChange={(e) => setConfig({ ...config, mqttRetain: e.target.checked })}
              className="w-4 h-4 text-primary-600 border-gray-300 rounded focus:ring-primary-500"
            />
            <label htmlFor="mqttRetain" className="ml-2 text-sm text-gray-700">
              Retener mensajes (Retain Flag)
            </label>
          </div>
        </div>
      </div>

      {/* Configuración de Logs */}
      <div className="card">
        <div className="flex items-center space-x-3 mb-4">
          <Database className="w-6 h-6 text-primary-600" />
          <h3 className="text-lg font-semibold text-gray-900">Logs y Depuración</h3>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Nivel de Log
          </label>
          <select
            value={config.logLevel}
            onChange={(e) => setConfig({ ...config, logLevel: e.target.value })}
            className="input"
          >
            <option value="error">Error</option>
            <option value="warn">Warning</option>
            <option value="info">Info</option>
            <option value="debug">Debug</option>
          </select>
        </div>
      </div>

      {/* Información del Sistema */}
      <div className="card bg-gray-50">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Información del Sistema</h3>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <span className="text-gray-600">Versión:</span>
            <span className="ml-2 font-medium">1.0.0</span>
          </div>
          <div>
            <span className="text-gray-600">Planta:</span>
            <span className="ml-2 font-medium">{plantaId.toUpperCase() === 'GVBIO' || plantaId.toLowerCase() === 'gvbio' ? 'PLANTA 1' : plantaId}</span>
          </div>
          <div>
            <span className="text-gray-600">Protocolo OPC UA:</span>
            <span className="ml-2 font-medium">Part 14 PubSub</span>
          </div>
          <div>
            <span className="text-gray-600">MQTT Broker:</span>
            <span className="ml-2 font-medium">Mosquitto 2.0</span>
          </div>
        </div>
      </div>

      {/* Botón Guardar */}
      <button
        onClick={handleSave}
        className="btn btn-primary w-full flex items-center justify-center space-x-2"
      >
        <Save className="w-5 h-5" />
        <span>Guardar Configuración</span>
      </button>
    </div>
  );
}

export default ConfigPanel;
